export const CLIENT_LEDGER_ENTRY_TYPES = {
  PAYMENT: "PAYMENT",
  OPENING_BALANCE: "OPENING_BALANCE",
  MONTHLY_CHARGE: "MONTHLY_CHARGE",
  ENROLLMENT_CHARGE: "ENROLLMENT_CHARGE",
};

export const PAYMENT_METHODS = {
  TRANSFER: "TRANSFER",
  CASH: "CASH",
  CARD: "CARD",
  OTHER: "OTHER",
};

export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHODS.TRANSFER, text: "Przelew" },
  { value: PAYMENT_METHODS.CASH, text: "Gotowka" },
  { value: PAYMENT_METHODS.CARD, text: "Karta" },
  { value: PAYMENT_METHODS.OTHER, text: "Inne" },
];

export const PAYMENT_METHOD_LABELS = PAYMENT_METHOD_OPTIONS.reduce((labels, option) => ({
  ...labels,
  [option.value]: option.text,
}), {});

export const CLIENT_LEDGER_TYPE_LABELS = {
  [CLIENT_LEDGER_ENTRY_TYPES.PAYMENT]: "Wplata",
  [CLIENT_LEDGER_ENTRY_TYPES.OPENING_BALANCE]: "Saldo poczatkowe",
  [CLIENT_LEDGER_ENTRY_TYPES.MONTHLY_CHARGE]: "Naliczenie miesieczne",
  [CLIENT_LEDGER_ENTRY_TYPES.ENROLLMENT_CHARGE]: "Naliczenie z zapisu",
};

export const formatLedgerAmount = amount => `${Number(amount || 0).toFixed(2)} zl`;
